<template>
    <div class="automation-trigger-settings">
        <p>
            {{ t('automations-form-triggers_config-quotation_status_change-description') }}
        </p>

        <div class="field">
            <label :class="{ label: true }">{{ t('automations-form-triggers_config-quotation_status_change-status_label') }} </label>
            <select v-model="filterStatus" class="form-control" multiple>
                <option value="all">{{ t('automations-form-triggers_config-quotation_status_change-all_status') }}</option>
                <option
                    v-for="status in statusList"
                    :value="status.id"
                    :key="status.id"
                >
                    {{ status.external_label }}
                </option>
            </select>
        </div>

        <div class="field filter-value">
            <label
                :class="{
                    label: true,
                    'label-danger': !isFieldValid('filterValue'),
                }"
                ><input type="checkbox" v-model="filterValue" /> {{ t('automations-form-triggers_config-quotation_status_change-filter_value_label') }}</label
            >
            <div class="row inputs" v-if="filterValue">
                <div class="col-6">
                    <span
                        :class="{
                            label: true,
                            'label-danger': !isFieldValid('minValue'),
                        }"
                        >{{ t('automations-form-triggers_config-quotation_status_change-min_value_label') }}</span
                    >
                    <input
                        type="tel"
                        v-model.lazy="minValue"
                        v-money="$store.state.money"
                        class="form-control"
                    />
                </div>
                <div class="col-6">
                    <span
                        :class="{
                            label: true,
                            'label-danger': !isFieldValid('maxValue'),
                        }"
                        >{{ t('automations-form-triggers_config-quotation_status_change-max_value_label') }}</span
                    >
                    <input
                        type="tel"
                        v-model.lazy="maxValue"
                        v-money="$store.state.money"
                        class="form-control"
                    />
                </div>
            </div>
        </div>
        <div
            class="field filter-value"
            v-for="field in fieldsThatCanFilter"
            :key="field.id"
        >
            <template v-if="customFieldsFilter[field.id] !== undefined">
                <label :class="{ label: true }">
                    <input
                        type="checkbox"
                        v-model="customFieldsFilter[field.id]['enabled']"
                    />
                    {{ t('automations-form-triggers_config-quotation_status_change-filter_field_label', [field.field_name]) }}</label
                >

                <div v-show="customFieldsFilter[field.id]['enabled']">
                    <input
                        type="text"
                        class="form-control"
                        v-model="customFieldsFilter[field.id]['valueEqual']"
                        :placeholder="t('automations-form-triggers_config-quotation_status_change-placeholder_equal')"
                    />
                </div>
            </template>
        </div>
    </div>
</template>
<style lang="less">
.filter-value {
    .row.inputs {
        margin-top: 10px;
    }
    input {
        margin-top: 4px;
    }
}
</style>
<script>
import keviApi from "../../../keviApi";

export default {
    props: {
        value: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        let filterStatus =
            this.value.length > 0 && this.value[0].filterStatus
                ? this.value[0].filterStatus
                : false;
        if (filterStatus && !Array.isArray(filterStatus)) {
            filterStatus = [filterStatus];
        }

        let minValue =
            this.value.length > 0 && this.value[0].minValue
                ? this.float(this.value[0].minValue).toFixed(2)
                : null;
        let maxValue =
            this.value.length > 0 && this.value[0].maxValue
                ? this.float(this.value[0].maxValue).toFixed(2)
                : null;
        let filterValue =
            this.value.length > 0 && this.value[0].filterValue
                ? this.value[0].filterValue
                : false;
        return {
            filterStatus: filterStatus,
            filterValue: filterValue,
            minValue: minValue,
            maxValue: maxValue,
            customFieldsFilter: {},
            fields: [],
            statusList: [],
        };
    },
    computed: {
        fieldsThatCanFilter() {
            return this.fields.filter(this.canFilterByField);
        },
        errors() {
            let errors = {};

            if (!this.filterStatus) {
                errors["filterStatus"] = "empty";
            }

            let max = this.float(this.maxValue);
            let min = this.float(this.minValue);
            if (this.filterValue && max <= 0) {
                errors["filterValue"] = "invalid-max";
                errors["maxValue"] = "invalid";
            }
            if (this.filterValue && min >= max && min > 0) {
                errors["filterValue"] = "min-greater-than-max";
                errors["minValue"] = "greater-than-max";
            }
            return errors;
        },
        floatMax() {
            return this.float(this.maxValue);
        },
    },
    mounted: function () {
        this.loadFields();
        this.loadStatusList();
        window.setTimeout(() => {
            this.changed();
        }, 100);
    },
    methods: {
        t(term, replaces) {
            return this.$root.t(term, replaces);
        },
        loadStatusList() {
            let options = keviApi.getOptions(
                "settings/external-quotations-status",
                "GET",
            );
            this.$http(options).then((response) => {
                this.loading = false;
                if (response.status === 200) {
                    this.statusList = response.body.status || [];
                }
            });
        },
        canFilterByField(field) {
            return (
                parseInt(field.show_on_reports) === 1 &&
                ["text"].includes(field.type)
            );
        },
        getCustomFieldEmptyFilter() {
            return {
                enabled: false,
                valueEqual: "",
            };
        },
        loadFields() {
            let options = keviApi.getOptions("/quotation-fields", "GET");
            this.$http(options).then((response) => {
                response.body.forEach((field) => {
                    if (this.canFilterByField(field)) {
                        if (this.customFieldsFilter[field.id] === undefined) {
                            this.$set(
                                this.customFieldsFilter,
                                field.id,
                                this.getCustomFieldEmptyFilter(),
                            );
                        }
                    }
                });
                this.fields = response.body;
            });
        },
        float(number) {
            let result = 0.0;
            if (number === null) {
                result = parseFloat(0);
            }
            if (typeof number === "number") {
                result = parseFloat(number);
            }
            if (typeof number === "string") {
                result = parseFloat(
                    number
                        .replace(".", "")
                        .replace(",", ".")
                        .replace(/[^0-9.]/gm, ""),
                );
            }
            return result;
        },
        isFieldValid(field) {
            return !Object.keys(this.errors).includes(field);
        },
        isValid: function () {
            return Object.keys(this.errors).length === 0;
        },
        changed: function () {
            this.$emit("input", [
                {
                    filterStatus: this.filterStatus,
                    filterValue: this.filterValue,
                    minValue: this.float(this.minValue),
                    maxValue: this.float(this.maxValue),
                    customFieldsFilter: this.customFieldsFilter,
                },
            ]);
        },
    },
    watch: {
        filterStatus: function () {
            this.changed();
        },
        filter: function () {
            this.changed();
        },
        filterValue: function () {
            this.changed();
        },
        minValue: function () {
            this.changed();
        },
        maxValue: function () {
            this.changed();
        },
        customFieldsFilter: {
            handler: function () {
                this.changed();
            },
            deep: true,
        },
        value: function () {
            let filterStatus =
                this.value.length > 0 && this.value[0].filterStatus
                    ? this.value[0].filterStatus
                    : false;
            if (filterStatus && !Array.isArray(filterStatus)) {
                filterStatus = [filterStatus];
            }
            let filter =
                this.value.length > 0 && this.value[0].filter
                    ? parseInt(this.value[0].filter)
                    : null;
            if (filter !== this.filter) {
                this.filter = filter;
            }
            if (filterStatus !== this.filterStatus) {
                this.filterStatus = filterStatus;
            }

            if (
                this.value[0] &&
                this.value[0].customFieldsFilter !== undefined &&
                JSON.stringify(this.value[0].customFieldsFilter) !==
                    JSON.stringify(this.customFieldsFilter)
            ) {
                this.customFieldsFilter = this.value[0].customFieldsFilter;
            }

            let minValue =
                this.value.length > 0 && this.value[0].minValue
                    ? this.value[0].minValue
                    : null;
            if (this.float(minValue) !== this.float(this.minValue)) {
                this.minValue = this.float(minValue).toFixed(2);
            }

            let maxValue =
                this.value.length > 0 && this.value[0].maxValue
                    ? this.value[0].maxValue
                    : null;
            if (this.float(maxValue) !== this.float(this.maxValue)) {
                this.maxValue = this.float(maxValue).toFixed(2);
            }

            let filterValue =
                this.value.length > 0 && this.value[0].filterValue
                    ? this.value[0].filterValue
                    : false;

            if (!!this.filterValue !== !!filterValue) {
                this.filterValue = filterValue;
            }
        },
    },
};
</script>
